module.exports = __webpack_public_path__ + "c8c82edac499f7ee1493acfd23fa012a.svg";